module.exports = __webpack_public_path__ + "static/media/Brimstone.6e4eb17d.png";